import React, { useState } from "react";
// import rajeev from "../director../images/rajeevahuja.png";

// import epilepto from "../../images/epilepto.png";
// import greeninv from "../../images/GREEN_INNOVOTECH.jpg";
import "./portfolio.css";
import { ExternalLink } from "lucide-react";
import Aviral from "./MouImg/Aviral.png";
import Awadh from "./MouImg/Awadh.png";
import Chandigarh from "./MouImg/Chandigarh.png";
import EY from "./MouImg/EY.png";
import ICMR from "./MouImg/ICMR.png";
import IIMT from "./MouImg/IIMT.png";
import IvyCap from "./MouImg/Ivycap.png";
import NEN from "./MouImg/NEN.png";
import PCTE from "./MouImg/PCTE.png";
import Pbti from "./MouImg/Pbti.png";
import Punjab from "./MouImg/startupPunjab.png";
import TiE from "./MouImg/TiE.png";
import indiaacc from "./MouImg/indiaacc.png";
import MSME from "./MouImg/MSME.png";
import SirAuro from "./MouImg/SirAuro.png";
import sucseed from "./MouImg/sucseed.png";
import iitrpr from "../../images/iitrprlogoWBG.jpg";
import I1 from "./MouImg/1.webp";
import UKIndia from "./MouImg/UKIndia.png";
import I3 from "./MouImg/3.png";
import I4 from "./MouImg/4.webp";
import PIOFEARC from "./MouImg/PIOFEARC.png";
import I7 from "./MouImg/7.png";
import EIL from "./MouImg/EIL.png";
import I11 from "./MouImg/11.png";
import CFIIE from "./MouImg/CFIIE.png";
import I13 from "./MouImg/13.png";
import I14 from "./MouImg/14.jpg";
import I15 from "./MouImg/15.webp";
import I16 from "./MouImg/16.png";
import I17 from "./MouImg/17.png";
import I18 from "./MouImg/18.png";
import I19 from "./MouImg/19.png";
import CIBIOD from "./MouImg/CIBIOD.png";
import Bharat_Petroleum from "./MouImg/Bharat Petroleum.png";
import Bharat_Dynamics from "./MouImg/Bharat dynamics.png";
import I24 from "./MouImg/24.png";
import WADHWANI from "./MouImg/WADHWANI.png";

// import IITRopar from "./MouImg/IITRopar.png";

import backg from "../../global-images/vector-about.png";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

const marqueeData = [
  {
    img: indiaacc,
    name: "India Accelerator Pvt Ltd",
    description: "Easecruit is a company that provides ",
    link: "https://www.nanokriti.com/",
  },
  {
    img: sucseed,
    name: "SucSEED  Innovation",
    description: "Ares Systems is a company that provides ",
    link: "https://www.nanokriti.com/",
  },
  {
    img: IvyCap,
    name: "IvyCap Ventures",
    link: "https://www.nanokriti.com/",
    description: "Bodyloop labs is a company that provides ",
  },
  {
    img: MSME,
    name: "Ministry of Micro, Small & Medium Enterprises (GOI)",
    link: "https://www.nanokriti.com/",
    description: "Edith Robotics Solutions is a company that provides ",
  },
  {
    img: Punjab,
    name: "StartUP Punjab",
    link: "https://www.nanokriti.com/",
    description: "ScratchNest is a company that provides ",
  },
  {
    img: Aviral,
    name: "Aviral Futuristic Management Consultant Pvt Ltd",
    link: "https://www.nanokriti.com/",
    description: "Vanix Technologies is a company that provides ",
  },
  {
    img: EY,
    name: "Ernst & Young LLP",
    link: "https://www.nanokriti.com/",
    description: "Yoboshu is a company that provides ",
  },
  {
    img: ICMR,
    name: "ICMR CIBIOD PGIMER",
    link: "https://www.nanokriti.com/",
    description: "Logier Technologies is a company that provides ",
  },
  // {
  //   img: jyoma,
  //   name: "Concerning the Establishment of AN EU-INDIA Incubator",
  //   link: "https://www.nanokriti.com/",
  //   description: "Jyoma Solutions is a company that provides ",
  // },
  // {
  //   img: greeninv,
  //   name: "Ganges Consulting",
  //   link: "https://www.nanokriti.com/",
  //   description: "Green Innovotech is a company that provides ",
  // },
  // {
  //   img: PCTE,
  //   name: "Punjab Biotechnology Incubator",
  //   link: "https://www.nanokriti.com/",
  //   description: "Neontram Pvt ltd is a company that provides ",
  // },
  {
    img: Chandigarh,
    name: "Chandigarh Angels Network",
    link: "https://www.nanokriti.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: TiE,
    name: "TiE Chandigarh",
    link: "https://www.nanokriti.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: NEN,
    name: "National Enterpreneurship Network",
    link: "https://www.nanokriti.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: IIMT,
    name: "IIMT University, Buisness Incubator",
    link: "https://www.nanokriti.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: SirAuro,
    name: "Sri Aurobindo College of Commerce and Management",
    link: "https://www.nanokriti.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  // {
  //   img: epilepto,
  //   name: "DCM Group of Schools",
  //   link: "https://www.nanokriti.com/",
  //   description:
  //     "Roschchcrete Technologies Pvt ltd is a company that provides ",
  // },
  {
    img: PCTE,
    name: "PCTE Group of Institutes",
    link: "https://www.nanokriti.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: iitrpr,
    name: "IIT ROPAR",
    link: "https://www.nanokriti.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: Awadh,
    name: "AWADH IIT ROPAR",
    link: "https://www.nanokriti.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: I1,
    name: "Ganges Consultancies",
    description: "",
    link: "",
  },
  {
    img: UKIndia,
    name: "UK INDIA Business Council",
    description: "",
    link: "",
  },
  {
    img: I3,
    name: "",
    description: "",
    link: "",
  },
  {
    img: PIOFEARC,
    name: "Postgraduate Institute of medical education and research chandigarh",
    description: "",
    link: "",
  },
  {
    img: I7,
    name: "NRL",
    description: "",
    link: "",
  },
  {
    img: EIL,
    name: "EIL",
    description: "",
    link: "",
  },
  {
    img: I11,
    name: "ISBA",
    description: "",
    link: "",
  },
  {
    img: CFIIE,
    name: "Center for Innovation Incubation & Entrepreneurship",
    description: "",
    link: "",
  },
  {
    img: I13,
    name: "ORDNANCE FACTORY CHANDIGARH",
    description: "",
    link: "",
  },
  {
    img: I14,
    name: "FICCI",
    description: "",
    link: "",
  },
  // {
  //   img: I15,
  //   name: "DCM GROUPS OF SCHOOLS",
  //   description: "",
  //   link: ""
  // },
  {
    img: I16,
    name: "GAIL",
    description: "",
    link: "",
  },
  {
    img: I18,
    name: "SBI",
    description: "",
    link: "",
  },
  {
    img: I19,
    name: "FINPORTAL",
    description: "",
    link: "",
  },
  {
    img: CIBIOD,
    name: "CIBiod",
    description: "",
    link: "",
  },
  {
    img: Bharat_Petroleum,
    name: "Bharat Petroleum",
    description: "",
    link: "",
  },
  {
    img: Bharat_Dynamics,
    name: "Bharat Dynamics Limited",
    description: "",
    link: "",
  },
  {
    img: I24,
    name: "SINE Business Incubator",
    description: "",
    link: "",
  },
  {
    img: WADHWANI,
    name: "Wadhwani Foundation",
    description: "",
    link: "",
  },
];
const sortedMarqueeData = marqueeData.sort((a, b) => {
  const nameA = a.name.toUpperCase(); // Ignore case
  const nameB = b.name.toUpperCase(); // Ignore case

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // Names must be equal
  return 0;
});
console.log(sortedMarqueeData);
// const itemsPerPage = 6;
function Portfolio() {
  const [currentPage, setCurrentPage] = useState(1);
  const element = document.getElementById("portfolio-box");
  // const totalPages = Math.ceil(marqueeData.length / itemsPerPage);

  // const handleClickNext = () => {
  //   if (currentPage < totalPages) {
  //     setCurrentPage(currentPage + 1);
  //   }
  //   if (element) {
  //     window.scrollTo({
  //       top: element.offsetTop,
  //       behavior: 'smooth'
  //     });
  //   }
  // };

  // const handleClickPrev = () => {
  //   if (currentPage > 1) {
  //     setCurrentPage(currentPage - 1);
  //   }
  //   if (element) {
  //     window.scrollTo({
  //       top: element.offsetTop,
  //       behavior: 'smooth'
  //     });
  //   }
  // };
  // const currentItems = marqueeData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    // <div className='w-screen'>
    <div
      className="bg-white flex items-center justify-center pt-32 "
      id="portfolio"
    >
      <div>
        <div>
          <h1 className="lg:text-5xl text-4xl text-black text-center ">
            <span className="text-blue-600 ">M</span>o
            <span className="">U</span> Signed{" "}
          </h1>
        </div>
        <div className="rounded-3xl ">
          <div className=" flex justify-center  items-center font-montserrat relative">
            {/* <div id='circle-1' className='absolute w-72 h-72 lg:top-0 lg:left-0 sm:top-50 sm:left-0 bg-purple-400 rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}

            <div className=" flex grid flex justify-center items-center relative p-6 ">
              {/* <div id='circle-3' className='absolute w-72 h-72 lg:top-0 lg:left-0 sm:top-0 sm:left-0 bg-red-400 animate-pulse  rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}
              {/* <div id='circle-2' className='absolute w-72 h-72 lg:top-40 lg:left-0 sm:top-0 sm:left-10 bg-indigo-400 rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}

              <div
                className="bg-white flex items-center justify-center"
                id="portfolio"
              >
                <div className="  rounded-3xl">
                  <div className=" flex justify-center  items-center font-montserrat relative">
                    {/* <div id='circle-1' className='absolute w-72 h-72 lg:top-0 lg:left-0 sm:top-50 sm:left-0 bg-purple-400 rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}

                    <div className=" flex grid grid-cols-1 flex justify-center items-center relative ">
                      {/* <div id='circle-3' className='absolute w-72 h-72 lg:top-0 lg:left-0 sm:top-0 sm:left-0 bg-red-400 animate-pulse  rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}
                      {/* <div id='circle-2' className='absolute w-72 h-72 lg:top-40 lg:left-0 sm:top-0 sm:left-10 bg-indigo-400 rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}

                      <div className="mt-10 flex grid lg:grid-cols-4 md:grid-cols-3 lg:gap-12  sm:grid-cols-2 gap-10">
                        {marqueeData.map((portfolio, index) => (
                          <div className="flex sm:w-full w-80 justify-center items-center bg-zinc-900 hover:scale-105 rounded-xl hover:transition hover:ease-in-out  hover:duration-150s">
                            
                            <div className="  cursor-pointer card img-card flex flex-col gap-6 mt-8 items-center">
                              <div className="flex w-52 h-48 rounded-3xl overflow-hidden bg-white justify-center items-center ">
                                <img
                                  className=" hover:rounded-lg bg-white "
                                  src={portfolio.img}
                                ></img>
                              </div>
                              <div className="">
                                <div
                                  className=" text-center text-xl font-montserrat text-white hover:underline hover:underline-offset-4"
                                  id="title"
                                >
                                  {portfolio.name}
                                </div>
                              </div>
                              <a
                                className="flex justify-around items-center "
                                href={portfolio.link}
                                target="_blank"
                              >
                                <button className="p-3 rounded-2xl ">
                                  <h2 className="text-md font-sans flex-row text-sky-400 hover:text-blue-600 hover-underline-animation">
                                    <span className="flex items-center">
                                      Visit Website
                                      <ExternalLink className="mb-1"></ExternalLink>
                                    </span>
                                  </h2>
                                </button>
                              </a>
                            </div>
                            {/* </div> */}
                            {/* </div> */}
                          </div>
                          // </div>
                        ))}
                        <div></div>
                        <div className="">
                          <div className="text-white underline-offset-4 underline  font-bold text-xl text-center m-4 p-4">
                            Page {currentPage}
                          </div>
                        </div>
                        {/* <div className='flex justify-end grid grid-cols-2 '>
                          <button className='text-white bg-red-800 hover:bg-pink-600  p-4 m-4 rounded-lg transition ease-in-out hover:scale-105 transform-400 hover:shadow-[0_0_10px_white]' onClick={handleClickPrev}>Previous</button>
                          <button className='text-white bg-green-900 hover:bg-emerald-400 m-4 rounded-lg transition ease-in-out hover:scale-105 transform-400 hover:shadow-[0_0_10px_white]' onClick={handleClickNext}>Next</button>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </div>
              <div className="bg-black lg:mt-20 lg:-translate-y-0 -translate-y-16 rounded-2xl py-12 sm:py-16 px-4 sm:px-6 lg:px-8 ">
                <div className="max-w-7xl mx-auto text-center flex grid justify-center items-center">
                  <div>
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white">
                      <span className="font-montserrat text-5xl">I</span>
                      nterested to Partner With US?
                    </h2>
                    <p className="mt-3 sm:mt-4 text-lg sm:text-xl text-gray-300">
                      We're always looking for Supportive Partners.
                    </p>
                  </div>
                  <div className="">
                    <a
                      href="/contact-us"
                      className="inline-flex items-center p-2 mt-10 font-mono  border border-transparent text-base hover:shadow-2xl text-white font-medium rounded-md bg-blue-500 hover:bg-blue-600 transition duration-150 ease-in-out"
                    >
                      Get in Touch
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
